/**
 * @file HttpStatus.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los códigos de estado HTTPStatus
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-12-19
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */
import { HttpStatusCode } from "@/types/httpStatusCode";

export const HTTPStatus: HttpStatusCode = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406,
  PRECONDITION_FAILED: 412,
  CONTENT_TOO_LARGE: 413,
  TOO_MANY_REQUEST: 429,
  IM_TEAPOT: 418,
  INTERNAL_SERVER_ERROR: 500,
  CONFLICT: 409,
  SERVER_ERROR: 500,
  LOCKED: 423,
};
